<template>
  <!--普通模板-->
  <div class="general">
    <template v-if="!isCorpUser">
      <!--    我的模板-->
      <div class="sp">
        <h1 class="com-title com-ht">
          <span><i></i>{{ isShowApiList ? "我的模板" : "企业模板" }}</span>&nbsp;
          <el-tooltip effect="dark" placement="bottom-end">
            <div slot="content">
              <p style="margin-bottom: 10px">
                <img style="max-width: 18px; margin-right: 10px" src="/images/advancedVersion/pdf_1.png" alt="">
                <span>变量模板:创建时可以添加变量，发起时填写变量信息</span>
              </p>
              <p>
                <img style="max-width: 18px; margin-right: 10px" src="/images/advancedVersion/file_1.png" alt="">
                <span>仅上传文件:创建时无需添加变量，发起时可在线编辑文件内容</span>
              </p>
            </div>
            <span class="el-icon-question"></span>
          </el-tooltip>
          <span
            v-if="!isInDingTalk"
            class="to-temp-sty"
          >海量合同模板供您参考&nbsp;&nbsp;<a
            :href="`${GlobalConfig.domain.junziqanIndex}/contract_template.html`"
            target="_blank"
            style="color: #ec1c1c"
          >立即前往&gt;&gt;</a
          ></span
          >
        </h1>
        <div class="search">
<!--          <el-button-->
<!--            class="data-btn"-->
<!--            type="text"-->
<!--            @click="templateAddChoose(0)"-->
<!--            v-if="!isInDingTalk"-->
<!--          >自定义模板创建 &gt;&gt;-->
<!--          </el-button>-->
          <el-input
            v-model="templateName"
            placeholder="请输入模板名称"
            size="small"
            clearable
            style="margin-right: 10px"
          ></el-input>
          <!-- class="searchIcon" -->
          <el-button size="small" @click="serchTemplate(templateName,1)"
          >查询
          </el-button
          >
          <el-button size="small" @click="reset">重置</el-button>
        </div>
      </div>
      <div class="box-wrap">
        <div class="temone" v-for="(item, index) in dataList" :key="index">
          <div class="t-box">
            <img
              v-if="beWord(item.tplName)"
              class="y-img"
              src="/images/advancedVersion/file_1.png"
            />
            <img v-else class="y-img" src="/images/advancedVersion/pdf_1.png"/>
            <p>{{ item.tplName }}</p>
            <div class="msk">
              <div class="list_one left-linear" style="border-bottom: 1px solid">
                <el-tooltip
                  effect="light"
                  content="修改"
                  placement="left"
                >
              <span
                class="el-icon-edit-outline setting_icon"
                style="margin-top: 1px"
                @click="modulesEditFn(item)"
                title=""
              ></span>
                </el-tooltip>
              </div>
              <div class="list_one top-linear" style="border-left: 1px solid">
                <el-tooltip
                  effect="light"
                  content="删除"
                  placement="right"
                >
              <span
                class="el-icon-delete setting_icon"
                @click="delTpl(item)"
                title=""
              ></span>
                </el-tooltip>
              </div>
              <div class="list_one bottom-linear" style="border-right: 1px solid; ">
                <el-tooltip
                  effect="light"
                  content="该模板允许授权给成员"
                  placement="left"
                >
                  <switch-button
                    v-model="item.allowMemberUse"
                    :object="item"
                    @confirmFn="seccondConfirmFn"
                  ></switch-button>
                </el-tooltip>
              </div>
              <div class="list_one right-linear" style="border-top: 1px solid; " v-if="item.tplType !== 4">
                <el-tooltip
                  effect="light"
                  content="查看"
                  placement="right"
                >
                  <span
                    class="el-icon-view setting_icon"
                    style="margin-top: 1px"
                    @click="viewDetailFn(item)"
                    title=""
                  ></span>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="template_auth" v-if="item.allowMemberUse">
            <div :class="['auth_btn', {'not_active': !authTemIdList.includes(item.tplId) || !item.allowMemberUse}]" @click="emitAuthListFn(item)">模板授权</div>
          </div>
          <div v-else class="no_template_auth">
            <span>授权成员使用已关闭</span>
          </div>
          <div :class="isManCorp ? 'a-btns-sty' : ''" v-show="isManCorp">
            <div class="a-btn" @click="templateUseFn(item)">立即使用</div>
            <div
              v-if="isAdVn(item) && !item.signerFixed"
              class="a-btn"
              @click="batchInit(item)"
            >
              批量发起
            </div>
          </div>
        </div>
        <!-- <div v-if="whetherSeniorUser"> 1197需求 隐藏自定义创建模板功能 -->
        <div class="temone add">
          <div style="padding: 20px">
            <span>选择创建方式</span>
            <div style="text-align: center; margin-top: 5px">
              <div class="add_button_style" @click="templateAddChoose(1)">
                PDF模板
              </div>
              <div
                style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
              >
                <el-upload
                  action="#"
                  accept=".doc,.docx"
                  :before-upload="fileOnBeforeUpload"
                  :show-file-list="false"
                  :file-list="fileList"
                  :on-error="fileOnError"
                >
                  <div class="add_button_style">仅上传文件</div>
                </el-upload>
<!--                <el-tooltip-->
<!--                  effect="dark"-->
<!--                  content="无需添加变量信息，发起时可以直接编辑文件内容"-->
<!--                  placement="top-start"-->
<!--                >-->
<!--                  <i class="el-icon-question"></i>-->
<!--                </el-tooltip>-->
              </div>
              <div class="add_button_style" @click="templateAddChoose(0)">
                自定义模板创建
              </div>
            </div>
          </div>
        </div>
        <!-- <div slot="reference" @click="templateAddChoose(1)" v-else>
          <div class="temone add">
            <span class="el-icon-plus"></span>
          </div>
        </div> -->
      </div>
    </template>
    <!--  系统模板  API模板-->
    <template v-if="isShowApiList">
      <!--    系统模板-->
      <!-- <h1 class="com-title com-ht"><i></i>系统模板</h1>
      <div class="box-wrap">
        <div class="temone" v-for="(item, index) in sysList" :key="index">
          <div class="t-box">
            <img class="y-img" src="/images/web/ye.png" />
            <p>{{ item.name }}</p>
          </div>
          <span class="a-btn" @click="systemUse">立即使用 </span>
        </div>
      </div> -->
      <!-- API模板-->
      <template v-if="!isInDingTalk">
        <h1 class="com-title com-ht"><i></i>API模板<el-button type="primary" size="mini" style="margin-left: 10px" @click="importVisible = true">导入</el-button></h1>
        <div class="box-wrap">
          <div
            class="temone temone-center"
            v-for="(item, index) in apiTemplateList"
            :key="index"
          >
            <div class="t-box">
              <img class="y-img" :src="item.tplVersion === 2 ? '/images/advancedVersion/pdf_1.png' :'/images/advancedVersion/file_html.png'"/>
              <p>{{ item.tplName }}</p>
              <div class="msk">
                <div class="list_one top-linear" style="border-right: 1px solid;">
                  <span
                    class="el-icon-edit-outline"
                    style="margin-top: 1px"
                    @click="APITempEdit(item)"
                    title="修改"
                  ></span>
                </div>
                <div class="list_one right-linear" style="border-bottom: 1px solid;">
                  <span
                    class="el-icon-delete"
                    @click="delApiTpl(item)"
                    title="删除"
                  ></span>
                </div>
                <div class="list_one left-linear"  style="border-top: 1px solid;">
                  <span
                    class="el-icon-folder"
                    @click="exportTemplateFn(item)"
                    title="导出"
                  ></span>
                </div>
              </div>
            </div>
            <div class="tpid">
              <div class="row-sty">ID:{{ item.serialNum }}</div>
              <div class="row-sty" v-show="item.tplVersion !== 2">模板编码:{{ item.tplCode }}</div>
              <div
                v-show="item.shareCode"
                :title="item.shareCode"
                class="row-sty"
              >
                共享编码:{{ item.shareCode }}
              </div>
            </div>
            <!--        <a class="a-btn">立即使用</a>-->
          </div>
          <div ref="apiTempAddRef">
            <div class="temone add">
              <div style="padding: 20px">
                <p>选择创建方式</p>
                <div style="text-align: center; margin-top: 10px">
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div class="add_button_style" @click="templateAddAPI">
                      PDF模板
                      <img src="/images/icon/new.png" alt="" class="new-icon">
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div class="add_button_style" @click="APIAdd">自定义模板创建</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </template>

    </template>

    <goto-auth :authDialog.sync="authDialog"></goto-auth>

    <!--批量发起弹窗-->
    <batch-launch
      v-if="plDialogVisible"
      :show.sync="plDialogVisible"
      :tplId="batchTplId"
    />
    <!-- onlyOffice -->
    <editor-pup
      :showofficeEditor.sync="showofficeEditor"
      :editor="editor"
      @saveLoading="saveLoading"
    ></editor-pup>
    <el-dialog title="模板授权" :visible.sync="TempAuth.visi" width="60%">
      <TempGrant :tempInfo="TempAuth.tempInfo"></TempGrant>
    </el-dialog>
<!--    导入模板的弹窗-->
    <el-dialog title="模板导入" :visible="importVisible" width="30%" :before-close="() => importVisible = false">
      <el-form :model="imTemplateForm" :rules="imTemplateRules" ref="imTemplateRef" label-width="120px" class="demo-ruleForm">
        <el-form-item label="上传模板文件：">
          <div v-if="imTemplateFile" class="im_template_avatar">
            <img v-if="imTemplateForm.tplType === 2" src="/images/advancedVersion/file_html.png" class="avatar">
            <img v-else src="/images/advancedVersion/pdf_1.png" class="avatar">
            <div class="im_tem_delete">
              <i class="el-icon-delete" style="font-size: 25px; cursor: pointer;" @click="deleteImTemplateFn"></i>
            </div>
          </div>
          <div class="im_template_upload" v-else>
            <el-upload
              class="avatar-uploader"
              action="#"
              accept="*"
              :show-file-list="false"
              :before-upload="beforeImTemplateUpload">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="模板名称：" prop="tplName">
          <el-input size="small" v-model="imTemplateForm.tplName"></el-input>
        </el-form-item>
        <el-form-item label="模板id：" prop="tplId" v-if="imTemplateForm.tplType === 2">
          <el-input size="small" v-model="imTemplateForm.tplId"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" size="small" :loading="importFileLoading" @click="importTemplateSubmit('ruleForm')">导入</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// components
import ElGo from "@/components/go/Go";
import editorPup from "@/components/onlyOffice/editorPup.vue";
import BatchLaunch from "@/components/advancedVersion/batchLaunch";
import switchButton from "@/components/switch-button/index";
import TempGrant from "./tempGrant.vue";
// API
import {
  ApiMethods,
  uploadFileAndConvertInfo
} from "@/assets/js/http-serve/http-methods";
import {listSystemTemplate} from "@/assets/js/http-serve/http-sysTpl";
// Tools
import {gantConf, getPermInfo} from "../../../assets/js/utils/jurisdiction";
import {mapGetters} from "vuex";
import GlobalConfig from "@/assets/js/config/global";
import {isInDingTalk} from "../../../assets/js/utils/ding-env";

  export default {
    components: {ElGo, BatchLaunch, switchButton, editorPup,TempGrant},
    data() {
      return {
        TempAuth:{
          visi:false,
          tempId:null,
          tempInfo:{}
        }, // 模板授权弹窗
        GlobalConfig,
        addVisi: false, // 我的模板添加按钮控制
        gantConf,
        isInDingTalk,
        editor: {},
        showofficeEditor: false,
        fileList: [],
        loading: false,
        paged: {itemPage: 1, pageSize: 9999},
        loadingList: false,
        dataList: [], // 我的模板
        authTemIdList: [], //授权给我的模板的id
        sysList: [], // 系统模板
        apiTemplateList: [], // api模板
        authorizationList: [], // 授权给我的模板
        authDialog: false,
        templateName: "", //模板名称（搜索）
        // 批量发起
        plDialogVisible: false,
        batchTplId: null,
        //  导入模板弹窗
        importVisible: false,
        imTemplateForm: {
          tplName: '',
          tplId: '',
          tplType: '',
        },
        imTemplateRules: {
          tplName: [
            {
              required: true,
              message: "请输入模板名称",
              trigger: ["change", "blur"]
            },
            // { validator: this.validatorPhone, trigger: "change" }
          ],
          tplId: [
            {
              required: true,
              message: "请输入模板id",
              trigger: ["change", "blur"]
            },
            // { validator: this.validatorPhone, trigger: "change" }
          ],
        },
        importFileLoading: false,
        imTemplateFile: null,
      };
    },
    methods: {
      //导入模板-文件选择
      beforeImTemplateUpload(file) {
        this.importFileLoading = true;
        let formData = new FormData();
        formData.append('file', file);
        //类型识别
        ApiMethods.ApiTemplateController.importFileType(formData).then(res => {
          this.importFileLoading = false;
          if (res.success) {
            this.imTemplateFile = file;
            this.imTemplateForm = res.data;
          } else {
            this.$message.warning(res.description)
          }
        })
      },
      //删除选择文件
      deleteImTemplateFn() {
        this.imTemplateFile = null;
      },
      //api导入模板submit
      importTemplateSubmit() {
        if (!this.imTemplateFile) {
          return this.$message.error('请选择文件！')
        }
        this.$refs.imTemplateRef.validate((valid) => {
          if (valid) {
            this.importTemplateFn();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //api导入模板
      async importTemplateFn(){
        let res = '';
        let formData = new FormData();
        formData.append('tplName', this.imTemplateForm.tplName)
        formData.append('file', this.imTemplateFile);
        if (this.imTemplateForm.tplType === 1) {
          res = await ApiMethods.ApiTemplateController.importFilePdf(formData)
        } else {
          formData.append('serialNum', this.imTemplateForm.tplId)
          res = await ApiMethods.ApiTemplateController.importFileHtml(formData)
        }
        if (res.success) {
          this.$message.success('操作成功')
          this.importTemSuccessFn()
        } else {
          this.$message.error(res.description)
        }
      },
      importTemSuccessFn () {
        this.$refs.imTemplateRef.resetFields();
        this.deleteImTemplateFn(); //删除文件
        this.importVisible = false;
        this.apiList();
      },
      //api导出模板
      exportTemplateFn(item) {
        console.log(item)
        if (item.tplVersion === 2) {
          ApiMethods.ApiTemplateController.exportFilePdf({tplId: item.tplId})
        } else {
          ApiMethods.ApiTemplateController.exportFileHtml({tplId: item.tplId})
        }
      },
      //查看模板
    viewDetailFn (item) {
      console.log('window.location.orange',window.location.orange);
      const path=`/advancedVersion/writeVariablesView?id=${item.tplId}&control=1`
      if(isInDingTalk){
        // dd.biz.util.invokeWorkbench({ app_url:window.location.origin + path })
        this.$router.push({
        path: "/advancedVersion/writeVariablesView",
        query: { id: item.tplId, control: 1 }
      });
      }else{
        window.open(window.location.origin + path)
      }
    },
      emitAuthListFn(item) {
        if (!this.authTemIdList.includes(item.tplId)) {
          return this.$message.error('暂无当前模板授权权限')
        } else {
          this.TempAuth.visi = true;
          this.TempAuth.tempInfo=item;
          // this.$emit("callbackFn", item.tplId);
        }
      },
      /** 我的模板新增按钮事件 */
      addTempPup() {
        const bool = this.permsEven()
        if (!bool) return
        this.addVisi = !this.addVisi
      },
      /** 权限验证 */
      permsEven(pid = gantConf.tempManageSub) {
        const perms = this.perms;
        const bool = perms.includes(pid);
        if (!bool) {
          const Pinfo = getPermInfo(pid)
          this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
        }
        return bool
      },
      /** API模板修改 */
      APITempEdit(item) {
        const bool = this.permsEven()
        if (!bool) return
        if(!(this.$store.getters.authUser.identityAuth > -1)) return this.authDialog = true
        const isAPITpl= item.tplVersion === 2, webTplPath={
            path: '/tpl/add/api',
            query: {tplId: item.tplId, control: 1, editorType: item.editorType},
          }
        isAPITpl ? this.templateAddAPI(item): this.$router.push(webTplPath)
      },
      // 调用loading并获取原文件
      saveLoading(sourceFile, tplId) {
        this.loadingStart();
        setTimeout(() => {
          this.loadingClose();
          this.editedFile(sourceFile, tplId);
        }, 5 * 1000);
      },
      // 获取office编辑后的文件
      editedFile(sourceFile, tplId) {
        ApiMethods.onlyOfficeAPI.officeFile(sourceFile).then(res => {
          if (!res.success) return this.$message.error("网络异常，请重试");
          this.officePDFInfo({...res.data, tplId, tplFileType: 1});
        });
      },
      // office编辑后转换
      officePDFInfo(fileInfo) {
        this.loadingStart();
        const {fileName, targetId, fileType, tplId} = fileInfo;
        ApiMethods.AIDocSmart.converToPDF({...fileInfo}).then(res => {
          const {data} = res;
          if (res.success) {
            const file = {
              fileName: fileName,
              fileType: 1,
              tempFile: data.tempFile,
              items: data.items,
              sort: null,
              tplId,
              fileOperVO: {
                docHash: data.docHash,
                extendsLocation: "",
                fileName: fileName,
                fileType: 3,
                sign: data.tempFile.sign,
                targetId: data.tempFile.targetId,
                targetIdForPreview: "",
                ts: data.tempFile.ts
              },
              sourceFile: fileInfo
            };
            this.fileList = [{...file, tplFileType: 1}];
            this.onlyfileUp();
          } else {
            this.$message.error(res.description);
          }
          this.loadingClose();
        });
      },
      // onlyoffice 编辑
      InOnlyOffice(file) {
        this.loadingStart();
        ApiMethods.TemplateController.advanceVDetailByID(file.tplId).then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          const {files} = res.data.context;
          const sourceFile = files[0].sourceFile;
          this.openEditor(
            {fileName: files[0].fileName, ...sourceFile},
            file.tplId
          );
        });
      },
      // 打开编辑器
      openEditor(sourceFile, tplId) {
        ApiMethods.onlyOfficeAPI
          .getOfficeConfig(sourceFile)
          .then(res => {
            console.log("res", res);
            if (!res.success) return this.$message.error(res.description);
            const {data} = res;
            this.editor = {
              // width: "100%", height: "100%",
              editorConfig: {...data},
              sourceFile,
              fileIndex: tplId
            };
            this.showofficeEditor = true;
          })
          .finally(() => {
            this.loadingClose();
          });
      },
      // 判断文件是否是doc类型
      beWord(fileName) {
        let filesuffix = "";
        if (fileName) {
          let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
          let namelength = fileName.length; //取到文件名长度
          filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
        }
        return filesuffix === "doc" || filesuffix === "docx";
      },
      fileOnError(err) {
        console.log("文件上传出错", err);
        this.loadingClose();
      },
      // 新增多文件上传
      fileOnBeforeUpload(file) {
        const bool = this.permsEven()
        if (!bool) return;
        if (this.fileList.length >= 30) {
          return this.$message.error("当前可上传的文件不能超过30个！");
        }
        const re = new RegExp("(.doc|.docx)$", "i");
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!re.test(file.name)) {
          return this.$message.error("文件格式只能是doc/docx的文件");
        }
        if (!isLt20M) {
          return this.$message.error("上传文件大小不能超过 20MB!");
        }
        this.loadingStart("文件上传中~");
        uploadFileAndConvertInfo({
          file: file,
          fileType: 1,
          fileName: file.name,
          saveSourceFile: 1
        })
          .then(data => {
            const resInfo = {
              fileName: data.fileName,
              sourceFile: data.sourceFile,
              tplFileType: 1,
              tempFile: data.tempFile
            };
            this.fileList = [resInfo];
            this.onlyfileUp();
            this.loadingClose();
          })
          .catch(err => {
            console.log("err", err);
            this.loadingClose();
            this.$message.warning(err.description || "上传文件失败");
          });
      },
      /** 系统模板立即使用 */
      systemUse() {
        const bool = this.permsEven()
        if (!bool) return
        this.$router.push({
          path: '/tpl/add/sysContract',
          query: {typeName: item.typeName, control: 1},
        })
      },
      // 仅文件上传模板
      onlyfileUp() {
        this.loadingStart("正在保存文件模板~");
        const file = this.fileList[0];
        const param = {
          tplName: file.tplName || file.fileName,
          orderFlag: false,
          // inputGroups: file.inputGroups,
          // signers: this.signers,
          // 文件上传信息
          files: this.fileList,
          useTo: 1 // 仅文件上传
          // groupIdSet: this.selectNodes // 授权多个部门 id
        };
        if (file.tplId) param.tplId = file.tplId;
        console.log("param", param);
        ApiMethods.TemplateController.advanceVOperTpl(param).then(res => {
          if (res.success) {
            // 保存草稿弹窗
            this.$message.success("保存成功");
            this.fileList = [];
            this.setTplStatus(res.data, 2);
            this.queryList(this.templateName);
          } else {
            this.$message.error(res.description || this.$tip);
          }
          this.loadingClose();
        });
      },
      loadingStart(info = null) {
        this.loading = this.$loading({
          lock: true,
          text: info || "正在拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, .5)"
        });
      },
      //设置状态
      loadingClose() {
        this.loading = this.$loading({
          lock: true,
          text: "正在拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, .5)"
        });
        if (this.loading) {
          this.loading.close();
          this.loading = null;
        }
      },
      //我的模板编辑
      modulesEditFn(item) {
        const bool = this.permsEven()
        if (!bool) return
        if (this.beWord(item.tplName)) {
          this.InOnlyOffice(item);
          return;
        }
        if (this.$store.getters.authUser.identityAuth > -1) {
          //是否是高级用户
          if (this.whetherSeniorUser) {
            switch (item.tplVersion) {
              case 1:
                this.$router.push({
                  // path: "/console/authEdit",
                  path: item.editorType ? "/authEdit/variableEditor" : "/console/authEdit", //替换新编辑器地址-1903
                  query: {tplId: item.tplId}
                });
                break;
              case 2:
                this.$router.push({
                  path: "/advancedVersion/addTpl",
                  query: {id: item.tplId}
                });
                break;
              default:
                this.$router.push({
                  // path: "/tpl/add/general",
                  path: item.editorType ? "/authEdit/variableEditor" : "/tpl/add/general", //替换新编辑器地址-1903
                  query: {tplId: item.tplId}
                });
                break;
            }
          } else {
            this.$router.push({
              // path: "/tpl/add/general",
              path: item.editorType ? "/authEdit/variableEditor" : "/tpl/add/general", //替换新编辑器地址-1903
              query: {tplId: item.tplId}
            });
          }
        } else {
          this.authDialog = true;
        }
      },
      /**
       *  设置模板状态
       *  @status 1草稿，2启用，3停用，4删除
       * */
      setTplStatus(tplId, status, callback) {
        ApiMethods.TemplateController.advanceVSetStatus({
          tplId,
          status
        }).then(result => {
          if (!result.success)
            return this.$message.error(result.description || this.$tip);
        });
      },
      //我的模板立即使用
      templateUseFn: function (item) {
        const bool = this.permsEven()
        if (!bool) return
        if (this.beWord(item.tplName)) {
          // 纯文件模板
           //定义一个路径
          const {href} = this.$router.resolve({
            path: "/initiation/toCreate",
            query: {tplId: item.tplId}
          });
          isInDingTalk ? location.href = href : window.open(href, "_blank");
          return;
        }
        // control 标记是从控制台跳转过去的。页面中返回上一步按钮根据这个标记判断
        if (item.tplVersion === 2 && item.status === 1) {
          return this.$message.warning("模板未完成，请发布后使用");
        }
        let _path =null;
        if (this.whetherSeniorUser) {
          switch (item.tplVersion) {
            case 1:
              _path = this.$router.resolve({
                path: "/tpl/add/apply",
                query: {tplId: item.tplId, isAuth: 1, control: 1}
              });
              break;
            case 2:
              _path = this.$router.resolve({
                path: "/advancedVersion/writeVariables",
                query: {id: item.tplId, control: 1}
              });
              break;
            default:
              _path = this.$router.resolve({
                path: "/tpl/add/apply",
                query: {tplId: item.tplId, control: 1}
              });
              break;
          }
        } else {
          _path = this.$router.resolve({
            path: "/tpl/add/apply",
            query: {tplId: item.tplId, control: 1}
          });
        }
        const {href} = _path
        isInDingTalk ? location.href = href : window.open(href, "_blank");
      },
      /** 我的模板批量发起 */
      batchInit(item) {
        const bool = this.permsEven()
        if (!bool) return
        this.plDialogVisible = true
        this.batchTplId = item.tplId
      },
      //添加模板按钮
      templateAddChoose: function (val) {
        const bool = this.permsEven()
        if (!bool) return
        if (this.$store.getters.authUser.identityAuth > -1) {
          val
            ? this.$router.push({path: "/advancedVersion/addTpl"})
            : // : this.$router.push({ path: "/tpl/add/general" });
            this.$router.push({
              // path: "/console/authEdit",
              // path: "/authEdit/authEditNew",
              path: "/authEdit/variableEditor", //替换新编辑器地址-1903
              query: {tplId: ""}
              // query: {tplId: "", editorType: 1}
            });
        } else {
          this.authDialog = true;
        }
      },
      //二次确认函数
      seccondConfirmFn: function (switchVal, object) {
        const bool = this.permsEven()
        if (!bool) return
        return new Promise((resolve, reject) => {
          if (switchVal) {
            ApiMethods.TemplateController.allowMemberUseTem({
              tplId: object.tplId,
              tplVersion: object.tplVersion
            }).then(res => {
              if (res.success && res.code === "0") {
                this.getAuthTemListFn();
                resolve();
                // 存在权限。可以选择跳转到授权页面 反之提示成功
                if (perms && perms.includes(gantConf.tempAuth)) {
                  this.$confirm("开启成功，是否前往授权？", "系统提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  })
                    .then(() => {
                      this.$emit("update:tabAct", "grant");
                      // this.$router.push({
                      //   path: "/console/setting?activeName=tab-template"
                      // });
                    })
                    .catch(() => {
                    });
                } else {
                  this.$message.success("开启成功");
                }
              } else {
                this.$message.error(res.description || res.msg);
              }
            });
          } else {
            this.$confirm(
              "关闭之后授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续?",
              "系统提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(async () => {
                //prohibitMemberUserTem关闭成员使用模板
                let res = await ApiMethods.TemplateController.prohibitMemberUserTem(
                  {
                    tplId: object.tplId,
                    tplVersion: object.tplVersion
                  }
                );
                if (res.success && res.code === "0") {
                  resolve();
                  this.$message.success("关闭成功");
                } else {
                  this.$message.error(res.description || res.msg);
                }
              })
              .catch(() => {
              });
          }
        });
      },
      templateDelFn: async function (target) {
        const bool = this.permsEven()
        if (!bool) return
        let param = {tplId: target.tplId};
        let result = "";
        if (this.whetherSeniorUser) {
          switch (target.tplVersion) {
            case 1:
              result = await ApiMethods.TemplateController.delTplV1(param);
              break;
            case 2:
              result = await ApiMethods.TemplateController.delTplV2(param);
              break;
            default:
              result = await ApiMethods.TemplateController.delTpl(param);
              break;
          }
        } else {
          result = await ApiMethods.TemplateController.delTpl(param);
        }
        if (result.success) {
          this.$alert("操作成功", "系统提示", {
            confirmButtonText: "确定",
            callback: action => {
              this.queryList(this.templateName);
            }
          });
        } else {
          this.$message.error(result.description || this.$tip);
        }
      },
      delTpl: function (target) {
        const bool = this.permsEven()
        if (!bool) return
        let _this = this;
        _this
          .$confirm(
            "删除之后，该模板将彻底消失，授权的组织成员将无法使用该模板，已发起的合同不受影响，是否继续？",
            "系统提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
          .then(() => {
            this.templateDelFn(target);
          })
          .catch(() => {
          });
      },
      handleCurrentChange: function (val) {
        this.paged.pageNum = val;
        this.queryList(this.templateName);
      },
      handleSizeChange: function (val) {
        this.paged.pageSize = val;
        this.queryList(this.templateName);
      },
      /**
       *  我的模板
       * */
      queryList(name,toast) {
        this.getAuthTemListFn(); //跟着所有模板列表走不会错，嘿嘿
        let param = {
          itemPage: this.paged.pageNum,
          pageSize: this.paged.pageSize,
          tplName: name,
          entFilter: 1
        };
        this.loading = true;
        ApiMethods.TemplateController.listTpl(param)
          .then(result => {
            if (result.success) {
              if(toast) this.$message.success('操作成功')
              this.dataList = result.data;
              this.paged = {
                pageNum: result.pageNum,
                pageSize: result.pageSize,
                pages: result.pages,
                total: result.total
              };
            } else {
              if (this.$store.getters.authUser.identityAuth > -1)
                this.$message.error(result.description || this.$tip);
              return;
            }
          })
          .finally(() => {
            this.loadingList = false;
          });
      },
      /**
       *  api模板
       * */
      //添加模板按钮
      templateAddAPI: function (apiTplItem) {
        const bool = this.permsEven()
        if (!bool) return
        if (this.$store.getters.authUser.identityAuth > -1) {
          const query={apiPdf:1}
          if(apiTplItem) query.id = apiTplItem.tplId
          this.$router.push({path: "/advancedVersion/addTpl",query})
        } else {
          this.authDialog = true;
        }
      },
      apiList: function (name) {
        let param = {
          ...this.paged,
          // tplGroupTypeId:this.operGroupType.tplGroupTypeId
          tplName: name
        };
        ApiMethods.ApiTemplateController.listTpl(param)
          .then(result => {
            if (result.success) {
              this.apiTemplateList = result.data;
            } else {
              this.$message.error(result.description || this.$tip);
            }
          })
          .finally(() => {
            // this.loading = false;
          });
      },
      /** 添加API模板 */
      APIAdd() {
        const bool = this.permsEven()
        if (!bool) return
        this.$store.getters.authUser.identityAuth > -1
          ? this.$router.push({path: '/tpl/add/api', query: {control: 1}})
          : this.authDialog = true
      },
      /**
       *  删除api模板提示
       * */
      delApiTpl: function (target) {
        const bool = this.permsEven()
        if (!bool) return
        let _this = this;
        _this
          .$confirm("此操作将永久删除该模板, 是否继续?", "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.delAPITplHandle(target)
          })
          .catch(() => {
          });
      },
      /** 删除api模板 */
      delAPITplHandle(item){
        const {tplId,tplVersion} = item,_this=this
        const CUSTAPI = tplVersion === 2 ? ApiMethods.ApiTemplateController.delAPITpl : ApiMethods.ApiTemplateController.delTpl
        CUSTAPI({tplId}).then(result => {
          if (result.success) {
            _this.$alert("操作成功", "系统提示", {
              confirmButtonText: "确定",
              callback: action => {
                _this.apiList(_this.templateName);
              }
            });
          } else {
            _this.$alert(result.description || "操作失败", "系统提示");
          }
        });
      },
      /**
       *  系统模板
       * */
      listSysTpl: function () {
        listSystemTemplate().then(({data}) => {
          let arr = [];
          // 体验签署放最前面
          data.map(item => {
            if (item.typeName === "exper") {
              arr.unshift(item);
            } else {
              arr.push(item);
            }
          });
          this.sysList = arr;
        });
      },
      //获取授权给我的模板（下面那个不知道，应该是备注不对，接口逻辑早就改了，不是授权给我的）
      getAuthTemListFn() {
        ApiMethods.TemplateController.cmListTpl({
          tplName: '',
          itemPage: 1,
          pageSize: 9999, //this.pageSize
        }).then(result => {
          if (!result.success)
            return this.$message.error(result.description || this.$tip);
          if (result.data) {
            this.authTemIdList = result.data.map(item => {
              return item.tplId;
            })
          }
        });
      },
      /**
       *  授权给我的模板
       * */
      queryAuthorizationList(name) {
        const param = {...this.paged, tplName: name};
        ApiMethods.TemplateController.authTpl(param)
          .then(result => {
            if (!result.success)
              return this.$message.error(result.description || this.$tip);
            this.authorizationList = result.data;
            console.log(result.data);

            console.log("hahah");
          })
          .finally(() => {
            // this.loadingList = false
          });
      },

      // 当前是否高级模板
      isAdVn(item) {
        return +item.tplVersion === 2;
      },
      // 重置
      reset() {
        this.templateName = "";
        this.serchTemplate(this.templateName);
      },
      // 搜索模板
      serchTemplate(name,toast) {
        this.queryList(name,toast);
        this.isShowApiList && this.apiList(name);
        this.isShowAuthorizationList && this.queryAuthorizationList(name);
      }
    },
    computed: {
      ...mapGetters(["currentAuthUser", "allAuthUser"]),
      perms() {
        return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
      },
      //是否是高级企业用户
      whetherSeniorUser() {
        let currentAuthUser = this.currentAuthUser;
        let allAuthUser = this.$store.getters.allAuthUser;
        //判断是不是普通账号（超级管理员绑定在普通账号）true: 高级用户
        // return (
        //   currentAuthUser &&
        //   currentAuthUser.userType == 1 &&
        //   allAuthUser &&
        //   allAuthUser.corpCreateFlag == 1
        // );
        return true; //现在默认都是高级版
      },
      /**
       *  是否显示api模板
       * */
      isShowApiList() {
        // 查询 API 模板分类（企业用户激活API）
        if (
          this.allAuthUser &&
          this.allAuthUser.accountInfoVO.merchantFlag === 1
        ) {
          return true;
        }
        return false;
        //条件：（ !account || account.corpId != current.corpId）--结果-- 0 个人(有企业)--true 1 企业: false
        // let account = this.allAuthUser.manCorpUser;
        // let current = this.currentAuthUser;
        // return !(!account || account.corpId != current.corpId);
      },

      isCorpUser() {
        // try {
        //   console.log(this.currentAuthUser,this.currentAuthUser.superFlag,']]]')
        //   return this.currentAuthUser.superFlag !== undefined;
        // } catch (e) {
        //   return false;
        // }
        return false;
      },
      // 当前账号是否是登录账号
      isManCorp() {
        const name = this.currentAuthUser.corpName || this.currentAuthUser.name;
        return (
          this.allAuthUser &&
          this.allAuthUser.accountInfoVO.name === name &&
          this.currentAuthUser.userStemFrom !== -16
        );
      }
    },
    mounted() {
      // console.log("currentAuthUser", this.currentAuthUser.corpUserId);
      // console.log("allAuthUser", this.allAuthUser.manCorpUser.corpUserId);
      console.log('document.getElementById(apiTempAddRef)',this.$refs.apiTempAddRef);
      setTimeout(() => {
        if(this.$route.query.apiTem){this.$refs.apiTempAddRef && this.$refs.apiTempAddRef.scrollIntoView();}
      }, 500);
    },
    created() {
      if (this.isShowApiList) {
        this.apiList(this.templateName);
        this.listSysTpl();
      }
      this.queryList(this.templateName);
    },
    name: "tenpManage"
  };
</script>

<style lang="less" scoped>
  .to-temp-sty {
    margin-left: 20px;
    font-size: 14px;

    > a {
      &:active {
        color: #ec1c1c;
      }
    }
  }

  .row-sty {
    text-align: left;
    word-break: break-all;
  }

  .data-btn {
    width: 120px;
    margin-right: 20px;
    color: #dedbdc;

    &:hover {
      color: #dedbdc;
    }
  }

  .add_button_style {
    width: 120px;
    margin-bottom: 5px;
    color: #ffffff;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    // text-align: center;
    // background-color: #169bd5;
    background-color: #ec1c1c;
    position: relative;
    .new-icon{
      width: 25px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .general {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    max-width: 1366px;
    margin: 0 auto;
  }

  .tpl-table {
    border: 1px solid #ebebeb;
    border-bottom: 0;

    .action span {
      margin-right: 10px;
      cursor: pointer;
    }

    .action .span {
      margin-right: 10px;
    }
  }

  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
    min-height: 85px;
  }
@tem-width:175px;
  .box-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fill, @tem-width);
    align-items: flex-start;
    justify-items:center;
    justify-content: space-around;
    padding: 15px 20px;

    &:last-child {
      margin-bottom: 130px;
    }

    .temone {
      width: @tem-width;
      margin-bottom: 20px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;

      &.add {
        cursor: pointer;
        height: 140px;
        /*line-height: 140px;*/
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }

      &.temone-center {
        height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .t-box {
          width: 100%;
          /*height: 75%;*/
          height: 55%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          overflow: hidden;
          .tpid_btn_box {
            display: flex;
            justify-content: space-around;
            width: 90%;
            margin: 1px 0;
            .setting_icon {
              cursor: pointer;
              color: #290202a6;
              font-size: 16px;
              font-weight: bold;
            }
          }
          .y-img {
            margin-top: 0;
          }
        }

        .tpid {
          width: 100%;
          height: 45%;
          background: #eeeeee;
          overflow-y: auto;
          cursor: copy;
          > p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .no_template_auth {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color:#c0c4cc;
      }
      .template_auth {
        padding: 8px 3px;
        .auth_btn {
          border: 1px solid #290202;
          border-radius: 4px;
          font-size: 12px;
          color: #290202;
          cursor: pointer;
          padding: 2px 6px;
          &:hover {
            color: #ffffff;
            background-color: #ec1c1c;
            border: 1px solid #ec1c1c;
          }
          &.not_active {
            border: 1px solid #c0c0c0;
            color: #c0c0c0;
            &:hover {
              color: #ffffff;
              background-color: #c0c0c0;
              border: 1px solid #c0c0c0;
            }
          }
        }
      }
      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;
        &:hover {
          .msk {
            display: flex;
            width: 100%;
            height: 100%;
            opacity: 1;
            // 设置背景颜色以及透明度
            background: rgba(122, 113, 113, 0.35);
            // 背景的模糊大小通过下面的属性值大小来调制
            backdrop-filter: blur(1px);
          }
        }

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }

        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }

        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          align-items: center;
          display: none;
          .list_one {
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50%;
          }
          .left-linear{
            border-image-source: linear-gradient(to left,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .top-linear{
            border-image-source: linear-gradient(to top,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .bottom-linear{
            border-image-source: linear-gradient(to bottom,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .right-linear{
            border-image-source: linear-gradient(to right,#ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          .center-linear{
            border-image-source: linear-gradient(to bottom,transparent,#ccc, #ec1c1c,#ccc,transparent);
            border-image-slice: 1;
          }
          span {
            cursor: pointer;
            float: right;
            color: #ffffff;
            font-size: 20px;

            &:hover {
              color: rgba(236, 28, 28, 1);
            }
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          width: 50%;
        }
      }

      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }

  .a-btns-sty {
    display: flex !important;
    justify-content: space-around;
  }

  .a-btn {
    cursor: pointer;
    display: block;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);

    &:hover {
      color: rgba(236, 28, 28, 1);
      /*background:rgba(236,28,28,1);*/
    }
  }

  .search {
    display: flex;
    align-items: center;
    margin-right: 10px;
    border-radius: 4px;

    /deep/ .el-input__inner {
      border-radius: 4px 0 0 4px;
    }

    .searchIcon {
      padding: 7px 10px;
      border-radius: 0 3px 3px 0;
      background: rgb(222, 219, 220);
      border: 1px solid rgb(222, 219, 220);

      &:hover {
        background: #ec1c1c;
        border: 1px solid #ec1c1c;
      }
    }
  }

  .com-ht {
    /*justify-content: flex-start;*/
  }

  .sp {
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .com-ht {
      border-bottom: none;
    }
  }
  .avatar-uploader .el-upload {
    width: 150px;
    height: 170px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #ec1c1c;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 170px;
    line-height: 170px;
    text-align: center;
  }
  .im_template_upload {
    width: 150px;
    height: 170px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
  }
  .im_template_avatar {
    width: 150px;
    height: 170px;
    border-radius: 4px;
    position: relative;
    &:hover {
      .im_tem_delete {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        // 设置背景颜色以及透明度
        background: rgba(122, 113, 113, 0.2);
        // 背景的模糊大小通过下面的属性值大小来调制
        backdrop-filter: blur(1px);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .im_tem_delete {
      opacity: 0;
      display: none;
    }
    .avatar {
      width: 150px;
      height: 170px;
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// components/console/template/tempManage.vue